import { NgModule } from '@angular/core';
import { NgxLiveViewComponent } from './ngx-live-view.component';
import { TreeViewComponent } from './tree-view/tree-view.component';
import { VideoGridComponent } from './video-grid/video-grid.component';
import { GridComponent } from './grid/grid.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { I2vVideoGridComponent } from './i2v-video-grid/i2v-video-grid.component';
import { EventCardComponent } from './event-card/event-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WebPlayerComponent } from './web-player/web-player.component';
import {
  FullscreenOverlayContainer,
  OverlayContainer,
} from '@angular/cdk/overlay';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgxLiveViewService } from './ngx-live-view.service';
import { MatDialogModule } from '@angular/material/dialog';
import { EventDetailsComponent } from './event-details/event-details.component';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatBadgeModule } from '@angular/material/badge';
import { FilterComponent } from './filter/filter.component';
import { FaceCardComponent } from './face-card/face-card.component';
@NgModule({
  declarations: [
    NgxLiveViewComponent,
    TreeViewComponent,
    VideoGridComponent,
    GridComponent,
    I2vVideoGridComponent,
    EventCardComponent,
    WebPlayerComponent,
    EventDetailsComponent,
    FilterComponent,
    FaceCardComponent,
  ],
  imports: [
    MatMenuModule,
    MatIconModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    MatCardModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatExpansionModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatBadgeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    NgxLiveViewComponent,
    TreeViewComponent,
    VideoGridComponent,
    EventCardComponent,
  ],
  providers: [
    { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
    NgxLiveViewService,
  ],
})
export class NgxLiveViewModule {}
